// this service can only be called once per entrypoint
// Main idea is to minimize bare BackendData global usage

export default () => {
  const data = window.BackendData
  delete window.BackendData

  return data
}
